import { render, staticRenderFns } from "./OrdersByStatus.vue?vue&type=template&id=06a68162&scoped=true&"
import script from "./OrdersByStatus.vue?vue&type=script&lang=js&"
export * from "./OrdersByStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrdersByStatus.vue?vue&type=style&index=0&id=06a68162&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a68162",
  null
  
)

export default component.exports